import qs from 'query-string';

import * as attachmentsApi from '../../../api/attachments';
import * as documentApi from '../../../api/document';
import { invokeBlobFileDownloading } from '../../../utils/commonUtils';
import { getEnvVar } from '../../../utils/env';
import { mapLegacyRoute } from '../../../utils/legacyRouteMapper';
import * as rUtils from '../../../utils/ramdaUtils';
import { FILE_SOURCES, LINK_TARGETS } from '../../constants/runtime.constants';

export const mapTarget = (linkType) => {
  switch (Number(linkType)) {
    case 0:
      return LINK_TARGETS.NEW_WINDOW;
    case 1:
      return LINK_TARGETS.POPUP_WINDOW;
    case 2:
      return LINK_TARGETS.CURRENT_WINDOW;
    case 3:
      return LINK_TARGETS.WORKSPACE;
    default:
      return LINK_TARGETS.CURRENT_WINDOW;
  }
};

export const isExternalLink = (url) => url.match(/^(https?:|ftp:|file:|www\b)+/i);

export const prependProtocol = (url) => {
  if (url.match(/^(https?:|ftp:|file:\b)+/i)) {
    return url.replace('http:', 'https:');
  }
  return `https://${url}`;
};

export function getFileDownloadAPI(source) {
  switch (source) {
    case FILE_SOURCES.DOCUMENT_COMPARE:
      return documentApi.compareDocument;
    default:
      return attachmentsApi.fetchAttachmentFromServer;
  }
}

export async function fetchAttachmentFromServer(
  attachmentText,
  { enableBrowserHandling, fetchFileFromServer, source, ...params }
) {
  try {
    const fileDownloadAPI = fetchFileFromServer || getFileDownloadAPI(source);
    const { data, headers } = await fileDownloadAPI(params);

    let filename = attachmentText;

    const contentDisposition = headers['content-disposition'];
    if (contentDisposition) {
      [, filename] = contentDisposition.match(/filename="(.+?)"/);
    }

    if (enableBrowserHandling === 'true' && headers['content-type'] === 'application/pdf') {
      const fileURL = URL.createObjectURL(data);
      window.open(fileURL);
      return;
    }

    filename = decodeURIComponent(filename);
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(data, filename);
      return;
    }

    invokeBlobFileDownloading(data, filename);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`Fetching attachment for ssHyperlink failed : ${JSON.stringify(error)}`);
  }
}

export const goesToAdminApp = (url, mappedRoute) =>
  !isExternalLink(url) && mappedRoute.includes('.aspx');

export function preprocessPathname(url) {
  if (typeof url !== 'string') {
    throw new Error('Url should be string.');
  }

  const indexOfQMark = url.indexOf('?');
  const pathname = indexOfQMark >= 0 ? url.substring(0, indexOfQMark) : url;
  const mappedRoute = mapLegacyRoute(pathname);
  const leadingPages = mappedRoute.charAt(0) !== '/' ? '/Pages/' : '';

  return goesToAdminApp(url, mappedRoute)
    ? `${getEnvVar('REACT_APP_ADMIN_APP_URL')}${leadingPages}${mappedRoute}`
    : mappedRoute;
}

export function preprocessQueryString(url, pathname, token = '') {
  if (typeof url !== 'string') {
    throw new Error('Url should be string.');
  }

  const indexOfQMark = url.indexOf('?');
  const queryString = indexOfQMark >= 0 ? url.substring(indexOfQMark + 1) : '';

  if (goesToAdminApp(url, pathname)) {
    return `${queryString}${queryString.length > 0 ? '&' : ''}Token=${token}`;
  }

  const queryParams = rUtils.keysToCamelCase(qs.parse(queryString));

  return qs.stringify(queryParams);
}

export function preprocessUrl(url, token = '') {
  const pathname = preprocessPathname(url);
  const queryString = preprocessQueryString(url, pathname, token);

  return [pathname, queryString];
}
